"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _localeProvider = require("@alicd/next/lib/locale-provider");

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _WeekPicker = require("./WeekPicker");

var _WeekPicker2 = _interopRequireDefault(_WeekPicker);

var _locale = require("./locale");

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WeekPickerWithLocale = (0, _localeProvider2.default)(_WeekPicker2.default);
WeekPickerWithLocale.LOCALE = _locale2.default;
WeekPickerWithLocale.getWeekRange = _WeekPicker.getWeekRange;

exports.default = WeekPickerWithLocale;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-week-picker@0.0.4@@alicd/crui-week-picker/lib/index.js
// module id = 285
// module chunks = 0